let menu = [
    {
        id : 1,
        itemOf : 'Snacks',
        itemName : 'Vada Pav',
        itemImage : 'https://images.pexels.com/photos/16171915/pexels-photo-16171915/free-photo-of-dahi-vada.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 2,
        itemOf : 'Drinks',
        itemName : 'Whiskey',
        itemImage : 'https://images.pexels.com/photos/602750/pexels-photo-602750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 3,
        itemOf : 'Snacks',
        itemName : 'Spicy Noodles',
        itemImage : 'https://images.pexels.com/photos/2347311/pexels-photo-2347311.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 4,
        itemOf : 'Break Fast',
        itemName : 'Bread Bun',
        itemImage : 'https://images.pexels.com/photos/209206/pexels-photo-209206.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 5,
        itemOf : 'Dinner',
        itemName : 'Veg Burger',
        itemImage : 'https://images.pexels.com/photos/1639557/pexels-photo-1639557.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 6,
        itemOf : 'Lunch',
        itemName : 'Veg Pulaov',
        itemImage : 'https://images.pexels.com/photos/7593230/pexels-photo-7593230.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 7,
        itemOf : 'Drinks',
        itemName : 'Lemon Juice',
        itemImage : 'https://images.pexels.com/photos/7376996/pexels-photo-7376996.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 8,
        itemOf : 'Dinner',
        itemName : 'Burger & Fries',
        itemImage : 'https://images.pexels.com/photos/3356409/pexels-photo-3356409.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 9,
        itemOf : 'Break Fast',
        itemName : 'Cream Pie',
        itemImage : 'https://images.pexels.com/photos/263070/pexels-photo-263070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
    {
        id : 10,
        itemOf : 'Lunch',
        itemName : 'Egg Fried Rice',
        itemImage : 'https://images.pexels.com/photos/9609843/pexels-photo-9609843.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
        itemDesc : 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil tempore, amet iste a omnis consequatur non.',
    },
]

export default menu;